export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58')
];

export const server_loads = [0];

export const dictionary = {
		"/": [~7],
		"/account/login": [~8,[2]],
		"/account/oauth-error": [9,[2]],
		"/account/password-reset": [~10,[2]],
		"/account/register": [~11,[2]],
		"/account/reset-password": [~12,[2]],
		"/account/settings": [~13,[2]],
		"/account/settings/avatar": [14,[2]],
		"/account/settings/security": [15,[2]],
		"/admin": [~16],
		"/controller": [17],
		"/create": [~18],
		"/dashboard": [~19],
		"/dashboard/files": [20],
		"/docs": [21,[3]],
		"/docs/attribution": [33,[3]],
		"/docs/(markdown)/classquizcontroller": [22,[3,4]],
		"/docs/develop": [34,[3]],
		"/docs/(markdown)/features": [23,[3,4]],
		"/docs/(markdown)/features/custom-field": [24,[3,4]],
		"/docs/(markdown)/features/remote-control": [25,[3,4]],
		"/docs/import-from-kahoot": [35,[3]],
		"/docs/pow": [36,[3]],
		"/docs/privacy-policy": [37,[3]],
		"/docs/(markdown)/quiz/question-types": [26,[3,4]],
		"/docs/(markdown)/quiz/question-types/check-choice": [27,[3,4]],
		"/docs/(markdown)/quiz/question-types/multiple-choice": [28,[3,4]],
		"/docs/(markdown)/quiz/question-types/order": [29,[3,4]],
		"/docs/(markdown)/quiz/question-types/range": [30,[3,4]],
		"/docs/(markdown)/quiz/question-types/text": [31,[3,4]],
		"/docs/(markdown)/quiz/question-types/voting": [32,[3,4]],
		"/docs/roadmap": [38,[3]],
		"/docs/self-host": [39,[3]],
		"/docs/tos": [40,[3]],
		"/edit": [~41],
		"/edit/files": [42],
		"/edit/videos": [~43],
		"/explore": [44],
		"/import": [~45],
		"/moderation": [46],
		"/play": [~47],
		"/practice": [48],
		"/quiztivity/create": [49],
		"/quiztivity/edit": [50],
		"/quiztivity/play": [51,[],[5]],
		"/quiztivity/share/[share_id]": [~52],
		"/remote": [53],
		"/results": [54],
		"/results/[result_id]": [55],
		"/search": [56],
		"/user/[user_id]": [57],
		"/view/[quiz_id]": [~58,[],[6]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';